import * as remote from './remotes';
import * as stub from './stubs';
import { endpoints } from './endpoints';
import {
  ChangeContactInfo,
  GetConfirmation,
  GetMembershipDetails,
  GetMembershipStatus,
  CalculateCost,
  GetPaymentInfo,
  GetContent,
  SubmitMembershipChange,
  CancelScheduledPayment,
  GetWallet,
} from './contracts';
import { GetActiveMember } from './contracts/GetActiveMember';

type Sources = {
  getMembershipDetails: GetMembershipDetails;
  changeContactInfo: ChangeContactInfo;
  getMembershipStatus: GetMembershipStatus;
  getConfirmation: GetConfirmation;
  calculateCost: CalculateCost;
  getPaymentInfo: GetPaymentInfo;
  getContent: GetContent;
  getActiveMember: GetActiveMember;
  submitMembershipChange: SubmitMembershipChange;
  cancelScheduledPayment: CancelScheduledPayment;
  getAppleWallet: GetWallet;
  getAndroidWallet: GetWallet;
};

const stubs: Sources = {
  getMembershipDetails: stub.GetMembershipDetailsStub,
  changeContactInfo: stub.ChangeContactInfoStub,
  getMembershipStatus: stub.GetMembershipStatusStub,
  getConfirmation: stub.GetConfirmationStub,
  calculateCost: stub.CalculateCostStub,
  getPaymentInfo: stub.GetPaymentInfoStub,
  getContent: stub.GetContentStub,
  getActiveMember: stub.GetActiveMemberStub,
  submitMembershipChange: stub.SubmitMembershipChangeStub,
  cancelScheduledPayment: stub.CancelScheduledPaymentStub,
  getAppleWallet: stub.GetAppleWalletStub,
  getAndroidWallet: stub.GetAndroidWalletStub,
};

const remotes: Sources = {
  getMembershipDetails: remote.GetMembershipDetailsApi(endpoints.getMembershipDetails),
  changeContactInfo: remote.ChangeContactInfoApi(endpoints.changeContactInfo),
  getMembershipStatus: remote.GetMembershipStatusApi(endpoints.getMembershipStatus),
  getConfirmation: remote.GetConfirmationApi(endpoints.getConfirmation),
  calculateCost: remote.CalculateCostApi(endpoints.calculateCost),
  getPaymentInfo: remote.GetPaymentInfoApi(endpoints.getPaymentInfo),
  getContent: remote.GetContentApi(endpoints.getContent),
  getActiveMember: remote.GetActiveMemberApi(endpoints.getActiveMember),
  submitMembershipChange: remote.SubmitMembershipChangeApi(endpoints.prepayment),
  cancelScheduledPayment: remote.CancelScheduledPaymentApi(endpoints.cancelScheduledPayment),
  getAppleWallet: remote.GetAppleWalletApi(endpoints.getAppleWallet),
  getAndroidWallet: remote.GetAndroidWalletApi(endpoints.getAndroidWallet),
};


export const useRemote = process.env.NODE_ENV === 'production' || process.env.REACT_APP_SOURCES === 'remote' ? true : false;

export const sources = useRemote ? remotes : stubs;
